import { HandoverSection } from "../molecules/HandoverSection";
import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { ChevronRightIcon, Icon } from "ui/gluestack/icon";
import { CellListColumnModel, CellsList } from "../molecules/CellsList";
import { NoItemsComponent } from "ui/atoms/noItems";
import { CalendarEventModal } from "app/features/calendar/modals/CalendarEventModal";
import { ShiftHandoverTaskClass } from "../../../services/api/types/shiftHandover/classes/ShiftHandoverTaskClass";
import { useHandleShiftHandoverAppointments } from "../hooks/useHandleShiftHandoverAppointments";

interface Props {
  data: ShiftHandoverTaskClass[];
  isEditing?: boolean;
}

export function OverdueTasks({ data, isEditing }: Props) {
  const { ref, handleTaskRowPress } = useHandleShiftHandoverAppointments();

  const columns: CellListColumnModel<ShiftHandoverTaskClass>[] = [
    {
      title: "Appointment Type",
      key: "typeFriendly",
      renderData: (appointment) => (
        <Text className="font-semibold capitalize">
          {appointment.typeFriendly}
        </Text>
      ),
    },
    {
      title: "Description",
      key: "description",
    },
    {
      title: "Due Date/Time",
      key: "dueDateTime",
      renderData: (task) => {
        return (
          <View className="flex">
            <Text>{task.dueDateTime.time}</Text>
            <Text>{`(${task.dueDateTime.date})`}</Text>
          </View>
        );
      },
    },
    {
      title: "Status",
      key: "status",

      renderData: (task) => {
        return (
          <View className="flex max-w-24 ">
            <Text className="text-sm text-muted">{task.dueInfo}</Text>
          </View>
        );
      },
    },
    {
      title: "Preparation needed",
      key: "preparation_needed",
      renderData: (task) => {
        return <Text>{task.preparationNeeded ? "Yes" : "No"}</Text>;
      },
    },
    {
      title: "State",
      key: "state",
      renderData: (task) => {
        return (
          <View className="flex-row justify-between">
            <Text
              className={`${task.state.color} font-semibold first-letter:uppercase`}
            >
              {task.state.value}
            </Text>
            {isEditing ? <Icon as={ChevronRightIcon} /> : null}
          </View>
        );
      },
    },
  ];

  return (
    <HandoverSection title="Overdue" titleClassNames="text-warning-600">
      <>
        <CellsList
          data={data}
          columns={columns}
          onRowPress={isEditing ? handleTaskRowPress : undefined}
          noDataMessage={
            <NoItemsComponent
              title="Nothing overdue"
              subtitle="No overdue appointments"
            />
          }
          cellBackgroundColor="bg-warning-0"
        ></CellsList>

        <CalendarEventModal ref={ref} />
      </>
    </HandoverSection>
  );
}
